import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import BreakpointService from '@/core/responsive/breakpoints/breakpoint.service';
import InspirationalContentViewObject = Vertica.LouisPoulsen.Application.Content.Blocks.InspirationalContentViewObject;
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspirationalContentCell',
  props: {
    content: null,
    allowInView: { type: [Boolean, null] },
    showTitle: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    content: InspirationalContentViewObject,
    allowInView?: boolean | undefined,
    showTitle: boolean
}



const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);

const videoElement = ref(null);

const inView = ref<boolean>(false);

function setInView(): void {
    inView.value = true;
}

function showControls(state): void {
    const video = videoElement.value as HTMLVideoElement;
    video.controls = state;
}

function formatImageUrl(url, largeImage = false): string {
    return largeImage ? `${url}?maxwidth=1280` : `${url}?maxwidth=1024`;
}

const smallImageMediaQuery = computed<string>(() => {
    let width = 999;
    try { width = BreakpointService.breakpoints.medium.max; } catch (e) {}
    return `(max-width: ${width}px)`;
});

const linkUrl = computed<string | null>(() => {
    return props.content.link ? props.content.link.url : null;
});

const linkIsExternal = computed<boolean>(() => {
    return props.content.link && props.content.link.isExternal;
});

const openLinkInNewWindow = computed<boolean>(() => {
    return props.content.link && props.content.link.openInNewWindow;
});

const largeImageMediaQuery = computed<string>(() => {
    let width = 1000;
    try { width = BreakpointService.breakpoints.large.min; } catch (e) {}
    return `(min-width: ${width}px)`;
});

return { __sfc: true,props, textColor, videoElement, inView, setInView, showControls, formatImageUrl, smallImageMediaQuery, linkUrl, linkIsExternal, openLinkInNewWindow, largeImageMediaQuery }
}

})